export default __webpack_public_path__ + "static/media/oracle.429c2ebd.svg";